import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"


const api = new APIClient();

// Get List
export const getApiKey = () => api.get(url.GET_API_KEY, null)